import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';
import { useLocation } from 'react-router-dom';

export default function FloatingThemeToggle() {
  const { isDarkMode, toggleDarkMode } = useTheme();
  const location = useLocation();
  
  // Pages where we don't show the floating toggle (pages that already have it in header)
  const hiddenOnPages = ['/login', '/register', '/forgot-password', '/reset-password'];
  
  // Don't show on auth pages
  if (hiddenOnPages.some(page => location.pathname.startsWith(page))) {
    return null;
  }

  return (
    <button
      onClick={toggleDarkMode}
      className="fixed bottom-6 left-6 z-40 p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-105"
      style={{
        background: isDarkMode 
          ? 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%)'
          : 'linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)',
        border: `2px solid ${isDarkMode ? '#3b82f6' : '#3b82f6'}`,
        boxShadow: isDarkMode 
          ? '0 4px 14px -3px rgba(59, 130, 246, 0.4), 0 2px 6px -2px rgba(0, 0, 0, 0.3)'
          : '0 4px 14px -3px rgba(59, 130, 246, 0.3), 0 2px 6px -2px rgba(0, 0, 0, 0.1)'
      }}
      title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      data-testid="floating-theme-toggle"
    >
      {isDarkMode ? (
        <Sun className="w-5 h-5 text-yellow-300" />
      ) : (
        <Moon className="w-5 h-5 text-blue-600" />
      )}
    </button>
  );
}
